import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resetea el scroll al tope cada vez que cambia la ruta.
 * Úsalo una sola vez, dentro del <Router>, antes de <Routes>.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
}